import { ReactNode } from 'react';
import createSafeContext from '@paradigm/utils/src/createSafeContext';

import {
  SubscriptionState,
  useSubscriber,
} from '#/positions/contexts/abstractions/useSubscriber';
import { usePlatformStateWebsocket } from './websocket';
import { PlatformStateNotification, PlatformStateWebSocket } from './types';

const CHANNELS = ['platform_state'];
const TOPIC = 'platform-state-subscription';

export const [
  usePlatformStateSubscriberStatus,
  PlatformStateSubscriberContext,
] = createSafeContext<SubscriptionState>('PlatformStateSubscriberStatus');

interface Props {
  children: ReactNode;
}

export function PlatformStateSubscriptionProvider(props: Props) {
  const { children } = props;
  const ws = usePlatformStateWebsocket();
  const state = useSubscriber<
    PlatformStateWebSocket,
    PlatformStateNotification
  >(ws, CHANNELS, TOPIC);

  return (
    <PlatformStateSubscriberContext value={state}>
      {children}
    </PlatformStateSubscriberContext>
  );
}
